import React, {useEffect, useMemo} from "react";
import parse from "html-react-parser";
import DonationModule from "./DonationModule";
import CommentModule from "./CommentModule";
import StaticModule from "./StaticModule";
import {Link, useParams} from "react-router-dom";
import useFetchPage from "../../../../hooks/useFetchPage";

export default function Page() {
  const page = useFetchPage();

  const body = useMemo(() => {
    if(!page.data?.body) {
      return null;
    }

    return parse(page.data.body, {
      replace: domNode => {
        if (domNode.name === 'react-link') {
          return <Link {...domNode.attribs}>{domNode.attribs.text || "Go"}</Link>
        }
      }
    })
  }, [page.data?.body]);

  switch(page.data?.type) {
    case 'comment':
      return <CommentModule page={page} body={body} />;
    case 'donation':
      return <DonationModule page={page} body={body} />;
    default:
      return <StaticModule page={page} body={body} />;
  }
}
